import { createSlice } from "@reduxjs/toolkit";

const initialState = null;

const rcAutoFiltersSlice = createSlice({
  name: "rcAutoFilters",
  initialState,
  reducers: {
    setRcAutoFilters: (state, action) => action.payload,
    clearRcAutoFilters: () => null,
  },
});

export const { setRcAutoFilters, clearRcAutoFilters } =
  rcAutoFiltersSlice.actions;
export default rcAutoFiltersSlice.reducer;
